const card = "_uihckc3qqd";

export { card };
import "./card.style.linaria.module.css";
//# sourceMappingURL=card.style.js.map
